import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import CircledPlusIcon from '../icons/CircledPlus';
import FilmDescription from './FilmDescription';
import FilmTitle from './FilmTitle';
import IconLink from './IconLink';
import Link from './Link';
import Poster from './Poster';

import styles from '../../../styles/partials/film-details.module.scss';

const propTypes = {
    item: AppPropTypes.film,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    className: null,
};

const FilmDetails = ({ item, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <Link href={item.url} className={styles.filmPoster}>
            <Poster item={item} />
        </Link>

        <div className={styles.filmInfo}>
            <FilmTitle
                linkClassName={styles.filmLink}
                titleClassName={styles.filmTitle}
                url={item.url}
                item={item}
                isLink
            />

            <div className={classNames(styles.filmSynopsis)}>
                <FilmDescription className={styles.filmDescription} item={item} />
                <IconLink href={item.url} icon={<CircledPlusIcon />}>
                    <FormattedMessage
                        defaultMessage="View film page"
                        description="Carousel heading"
                    />
                </IconLink>
            </div>
        </div>
    </div>
);
FilmDetails.propTypes = propTypes;
FilmDetails.defaultProps = defaultProps;

export default FilmDetails;
